import styled from 'styled-components';
import { swwCalendarWidthWithPadding } from '@genericBookings/components/CustomDatepicker/styles';
import MediaSizes from '@widgets/shared/MediaSizes';
const arrowWidth = 270; // width including text
const arrowImageWidth = 83; // width of just image
const arrowOverlapAmount = 30; // how much it hangs over the calendar
export const Wrapper = styled.div `
  position: absolute;
  left: ${(swwCalendarWidthWithPadding - arrowWidth) + arrowOverlapAmount}px;
  bottom: -14rem;
  display: flex;
  align-items: flex-start;
  span.h1 {
    font-family: MouseMemoirs, Helvetica, sans-serif;
    font-size: 4rem;
    letter-spacing: -0.095rem;
    line-height: 4.8rem;
    text-align: center;
    text-transform: initial;
    font-weight: initial;
    margin-bottom: 0;
    transform: rotate(6deg);
    color: white;
  }
  
  @media screen and (min-width: ${MediaSizes.MD}px){
    display: none;
  }

  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    bottom: -18rem;
  }

  ${({ theme: { swwArrowWrapper } }) => swwArrowWrapper}
`;
export const Arrow = styled.picture `
  transform: rotate(154deg);
  position: relative;
  top: 2rem;
  
  img {
    width: ${arrowImageWidth}px;
    height: 30px;
  }
`;
export default {
    Wrapper,
};
